/** @jsx jsx */
import { Link } from 'gatsby';
import { jsx } from 'theme-ui';
import { Base } from './Button.styles';

/**
 * This button acts as a wrapper and dynamically chooses between
 * Gatsby's internal Link component, the browser anchor tag and a
 * regular button. If the `to` parameter is provided, a Link will be used.
 * If `to` is missing and `href` is provided, an anchor will be used.
 * Otherwise a regular button tag will be used.
 */
export default function Button({
  children,
  to,
  href,
  active,
  variant = 'primary',
  onClick,
  sx,
  ...rest
}) {
  const style = {
    ...Base,
    variant: active ? `buttons.${variant}.active` : `buttons.${variant}`,
  };

  if (to) {
    return (
      <Link to={to} onClick={onClick} sx={style} {...rest}>
        {children}
      </Link>
    );
  } else if (href) {
    return (
      <a href={href} onClick={onClick} sx={style} {...rest}>
        {children}
      </a>
    );
  } else {
    return (
      <button onClick={onClick} sx={style} {...rest}>
        {children}
      </button>
    );
  }
}
